/** Clase para los productos del cliente */
export default class RaterPriceClientProductCapitalized {
  /** (String): Código de cliente. */
  ClientCode!: string

  /** (String): Código de producto. */
  ProductCode!: string

  constructor(data: any) {
    this.ClientCode = data.ClientCode
    this.ProductCode = data.ProductCode
  }
}
